import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Scrollbars } from "react-custom-scrollbars";
import { store } from "../store";
import { queryGetBulkSmsCampaignList, mutationTriggerSendCampaign, mutationDeleteCampaign } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import Row from "./Row";
import CreateCampaign from './CreateCampaignWithQueryMutation'
import styled, { css } from 'styled-components'
import Button from "module-common/Button";

const ListGraphql = compose(
  graphql(queryGetBulkSmsCampaignList, {
    name: 'campaign',
    fetchPolicy: 'network-only'
  }),
  graphql(mutationTriggerSendCampaign, {
    name: 'triggerSendCampaign',
    refetchQueries: ['getBulkSmsCampaignList']
  }),
  graphql(mutationDeleteCampaign, {
    name: 'deleteCampaign'
  })
)(
  observer(
    class ListView extends Component {
      state = {
        isCreatingCampaign: false,
        isDraftOpen: false,
        draft: null
      }

      closeCreatePanel = () => {
        this.setState(state => ({...state, isCreatingCampaign: false, isDraftOpen: false, draft: null }))
      }

      openDraft = (campaign) => {
        this.setState(state => ({
          ...state, 
          isDraftOpen: true,
          draft: {
            id: campaign.id,
            campaignName: campaign.campaignName,
            content: campaign.content,
            selectedTagList: campaign.tagList
          }
        }))
      }

      sendCampaign = async (campaign) => {
        try {
          const result = await this.props.triggerSendCampaign({
            variables: {
              campaignId: campaign.id
            },
            refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
          })
          console.log(result)          
        } catch(e) {
          console.log(e, "Error on updating / creating draft!")
        } finally {
          
        }    
      }

      deleteCampaign = async (campaign) => {
        const isOk = window.confirm(`Are you sure to delete ${campaign.campaignName}? Deleting campaign will not delete the associated contacts.`)
        if(!isOk) return
        try {
          const result = await this.props.deleteCampaign({
            variables: {
              campaignId: campaign.id
            },
            refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
          })
          console.log(result)          
        } catch(e) {
          console.log(e, "Error on updating / creating draft!")
        } finally {

        }
      }

      render() {
        const { campaign: { loading, getBulkSmsCampaignList } } = this.props;
        const { isCreatingCampaign, isDraftOpen, draft } = this.state
        const renderList = !loading && getBulkSmsCampaignList && <Scrollbars
          ref={ref => (this.scroller = ref)}
        >
          {getBulkSmsCampaignList.map((item, index) => {
            return <Row 
              {...item} 
              index={index + 1} 
              onEdit={(campaign) => {
                this.openDraft(campaign)
              }}
              onSend={campaign => {
                this.sendCampaign(campaign)
              }}
              onDelete={campaign => {
                this.deleteCampaign(campaign)
              }}
            />
          })}
        </Scrollbars>
        const content = <Content>
            <ListWrapper>
                <ListTitle>
                    <Index>No.</Index>
                    <Name>Campaign</Name>
                    <Name>Content</Name>
                    <Name>Status</Name>
                    <Name>Tags</Name>
                    <Toolbox></Toolbox>
                </ListTitle>
                <ListBody>
                  {renderList}
                </ListBody>
            </ListWrapper>
        </Content>

        return (
          <React.Fragment>
            <CreateCampaignPanel>
              <Button
                color="blue"
                size="large"
                border
                onClick={() => {
                  this.setState(state => ({
                    ...state, 
                    isCreatingCampaign: state.isDraftOpen ? state.isCreatingCampaign : !state.isCreatingCampaign, 
                    isDraftOpen: state.isDraftOpen ? false : state.isDraftOpen
                  }))
                }}
              >
                {(isCreatingCampaign || isDraftOpen) ? 'Cancel' : 'Create Campaign'}
              </Button>
            </CreateCampaignPanel>  
            {isCreatingCampaign && <CreateCampaign onSuccess={() => setTimeout(() => { this.closeCreatePanel() }, 350)} />}
            {isDraftOpen && <CreateCampaign {...draft} campaignId={draft.id} isDraft={true} onSuccess={() => setTimeout(() => { this.closeCreatePanel() }, 350)} />}            
            {loading && <LoadingPanel />}
            {!loading && getBulkSmsCampaignList && (!isCreatingCampaign && !isDraftOpen) && content}                
          </React.Fragment>
        );
      }
    }
  )
);

export default observer(
  class List extends Component {
    render() {
      return <ListGraphql />;
    }
  }
);

const CreateCampaignPanel = styled.div`
  height: 50px;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid #d2d3d5;
`

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* overflow: scroll; */
`;

const Header = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d2d3d5;
`;

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #087cbc;
`;

const Back = styled.span`
  cursor: pointer;
`;

const Content = styled.div`
  padding: 10px 20px;
`;

const FilterWrapper = styled.div`
  width: 400px;
`;

const ListWrapper = styled.div`
  margin-top: 10px;
`;

const ListTitle = styled.div`
  background: #20445a;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
`;

const ListBody = styled.div`
  padding: 5px 10px;
  height: calc(74vh);
  width: 100%;
`

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
`;

const Toolbox = styled.div`
  flex: 5;
`;

const SocialMedia = styled.div`
  flex: 2;
  text-align: center;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;




// WEBPACK FOOTER //
// ./src/module-bulk-sms/campaign/ListWithQuery.js